import { render } from "./NarcoticProductModal.vue?vue&type=template&id=20bbf19c"
import script from "./NarcoticProductModal.vue?vue&type=script&lang=js"
export * from "./NarcoticProductModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__